import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SabisNgxFilePickerModule } from '../file-picker/sabis-filepicker.module';
import { SabisComponents2Module } from '../sabis-components2.module';
import { SabisNgxDialogModule } from '../sabis-dialog/sabis-dialog.module';
import { SabisNgxModalDialogComponent } from './inputs-dialog/inputs-dialog.component';



@NgModule({
  declarations: [
    SabisNgxModalDialogComponent
  ],
  imports: [ 
    CommonModule,
    FormsModule,

    SabisComponents2Module,
    SabisNgxDialogModule,
    SabisNgxFilePickerModule
  ],
  exports: [
    SabisNgxModalDialogComponent
  ]
})
export class SabisNgxModalsModule { }
